import React from "react";
import Main from "./containers/Main";

function App() {
  return (
      <Main />
  );
}

export default App;
